import { render, staticRenderFns } from "./DocumentTimer.vue?vue&type=template&id=0f90e814&scoped=true&"
import script from "./DocumentTimer.vue?vue&type=script&lang=js&"
export * from "./DocumentTimer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTimer.vue?vue&type=style&index=0&id=0f90e814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90e814",
  null
  
)

export default component.exports